import React from 'react';
import { formatDelta } from '../../../../utils/formatters';
import styles from './SimulationDeltaBar.module.css';

const SimulationDeltaBar = React.memo(function SimulationDeltaBar({
  totals,
  budgetPercentage,
  onApply,
  onDiscard,
}) {
  const { totalDelta, totalItems, totalQuoted, changeCount } = totals;
  const deltaClass =
    totalDelta > 0
      ? styles.deltaPositive
      : totalDelta < 0
        ? styles.deltaNegative
        : styles.deltaZero;

  return (
    <div className={styles.bar}>
      <div className={styles.info}>
        {totalDelta !== 0 && <span className={deltaClass}>{formatDelta(totalDelta)}</span>}
        {budgetPercentage && totalDelta !== 0 && (
          <span className={styles.percentage}>({budgetPercentage}% מהתקציב)</span>
        )}
        <span className={styles.meta}>
          {changeCount} שינויים · {totalItems} פריטים
          {totalQuoted > 0 && <span className={styles.quotedBadge}>· {totalQuoted} עם הצעה</span>}
        </span>
      </div>
      <div className={styles.actions}>
        <button className={styles.discardButton} onClick={onDiscard} type="button">
          בטל
        </button>
        <button className={styles.applyButton} onClick={onApply} type="button">
          שמור שינויים
        </button>
      </div>
    </div>
  );
});

export default SimulationDeltaBar;
